'use strict';
const progressSortConfig = require('../models/progress-sort-config'),
	_ = require('underscore'),
	mmWidgets = require('./mm-widgets');

mmWidgets.fn.progressStatusMenuWidget = function (progressModel, resourceDecompressor) {
	const resourceToUrl = resourceDecompressor || (x => x),
		updateIcon = function (selector, icon, color) {
			if (icon) {
				selector.addClass('status-icon-image').css('background-image',  'url(' + resourceToUrl(icon.url) + ')');
			} else {
				selector.removeClass('status-icon-image').css('background-image',  '');
			}
			selector.css('backgroundColor', color);
		};
	return mmWidgets.each(this, function () {
		const element = this,
			template = element.find('[data-mm-role~="status-template"]').detach(),
			showConfigStatuses = function (config) {
				element.empty();

				if (!config) {
					return;
				}
				const sortedConfig = progressSortConfig(config);
				_.each(sortedConfig, function (status) {
					const newItem = template.clone().appendTo(element);
					newItem.attr('data-mm-progress-status', status.key);
					updateIcon(newItem.find('[data-mm-role~="status-icon"]'), status.icon, (status.style && status.style.background));
					newItem.find('[data-mm-role~="status-name"]').text(status.description);
					newItem.find('[data-mm-role~="status-selector"]').click(function () {
						progressModel.updateActivatedStatus(status.key);
					});
					newItem.find('[data-mm-role~="status-checkbox"]').prop('checked', true).val(status.key);
					newItem.find('[data-mm-role~="status-checkbox"]').click(function (e) {
						progressModel.setFilterStatus(status.key, e.target.checked);
					});
					progressModel.addEventListener('dataUpdated', function (newData, newFilter) {
						let checked = false;
						if (!newFilter || !newFilter.statuses) {
							checked = true;
						} else if (_.contains(newFilter.statuses, status.key)) {
							checked = true;
						}
						newItem.find('[data-mm-role~="status-checkbox"]').prop('checked', checked);
					});

				});
			};
		progressModel.addEventListener('configChanged', showConfigStatuses);
		progressModel.addEventListener('progressContext', function (context) {
			if (context.isActive && context.currentStatusConfig) {
				showConfigStatuses(context.currentStatusConfig);
			} else {
				showConfigStatuses();
			}
		});
	});

};
